import { useState } from 'react';
import VyModal from '../../../common/VyModal';
import MatchesList from './MatchesList';

const PBMatchingModal = ({ onClose }: { onClose: () => void }) => {
  const [actions, setActions] = useState<JSX.Element[]>([]);

  return (
    <VyModal open={true} maxWidth={'100vw'} onClose={onClose} hasDefaultPadding={false}>
      {(onClose) => (
        <div className="p-2" style={{ minWidth: '50vw' }}>
          <MatchesList setActions={setActions} />
        </div>
      )}
    </VyModal>
  );
};
export default PBMatchingModal;
